import React, { useRef, useState } from "react";


const testimonials = [
  {
    id: 1, text: "My internship at AlgoAnalytics provided an incredible foundation for my career, and I will always be grateful for the experience. The learning environment is exceptional, offering hands-on work that is both challenging and rewarding. I doubt many companies provide such meaningful opportunities to their interns.The team at AlgoAnalytics is supportive and cooperative, making the entire experience even more enriching. I'm thankful for the skills and knowledge I gained, which have been truly invaluable to my growth.",
    img: "assets/images/image-intern-round.png", internName: "~Rohit Virkar, VIT Pune"
  },
  {
    id: 2, text: "Starting my journey as a Data Science intern at AlgoAnalytics, was an incredible opportunity. From the outset, I found myself not only diving deep into data science but also exploring the world of UI/UX design. This dual role gave me a broader understanding of how data science interacts with user experience-a skill I continue to hone as I work closely with various teams. It's been an amazing journey, one where I've gained technical knowledge, leadership experience, and creative problem-solving skills. I'm excited to keep growing with AlgoAnalytics and see where this adventure takes me next!",
    img: "assets/images/image-intern-round.png", internName: "~Prerana Nimhan, COEP Pune"
  },
  {
    id: 3, text: "AlgoAnalytics has been an incredible platform to launch my career, providing me with invaluable learning experiences. I've had the opportunity to work on cutting-edge technologies and collaborate with industry leaders, which has broadened my perspective. The mentorship and hands-on projects have truly shaped my skills and professional growth. I'm deeply thankful for the continuous support and the chance to contribute to impactful projects. It's been a rewarding journey that has prepared me for the future.",
    img: "assets/images/image-intern-round.png", internName: "~Mihir Apte, Marathwada Mitra Mandal's College of Engineering"
  }
];

const TestimonialCarousel = () => {
  const [index, setIndex] = useState(0);
  const nextSlide = () => setIndex((prev) => (prev + 1) % testimonials.length);
  const prevSlide = () => setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  const carouselRef = useRef(null);

  const handleScroll = (event) => {
    event.preventDefault();
    if (carouselRef.current) {
      carouselRef.current.scrollLeft += event.deltaY;
    }
  };

  return (
    <div className="container">
      <div className="carousel-wrapper">
        <div className="testimonial-carousel" ref={carouselRef} onWheel={handleScroll}
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-slide">
              <div className="testimonial-circle">
                <img src={testimonial.img} alt="Testimonial" />
              </div>
              <div className="testimonial-rectangle">
                <div className='testimoninal-text'>
                  <div style={{ fontSize: '14px', textAlign: 'left' }}>"{testimonial.text}"</div>
                </div>
                <div class="text-bottom-right">{testimonial.internName}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='slick-arrows career-arrow d-flex align-items-center' style={{ justifyContent: "center" }}>
        <button className='slick-arrow-left slick-arrow'
          onClick={prevSlide}
        >
          <svg
            width='27'
            height='22'
            viewBox='0 0 27 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12.2308 1.91748L3 11L12.2308 20.0824M27 11.0563L4.84615 11.0563'
              stroke='#86909F'
              stroke-width='3'
            />
          </svg>
        </button>
        <button className='slick-arrow-right slick-arrow'
          onClick={nextSlide}
        >
          <svg
            width='27'
            height='22'
            viewBox='0 0 27 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12.2308 1.91748L3 11L12.2308 20.0824M27 11.0563L4.84615 11.0563'
              stroke='#86909F'
              stroke-width='3'
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
